var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VProgressCircular',{staticClass:"ma-auto home-loader-spinner",attrs:{"size":56,"indeterminate":"","color":"accent"}})}
var staticRenderFns = []

export { render, staticRenderFns }